<template>
  <span class="text-xl font-light text-gray-800"><slot></slot></span>
</template>
